/**
 * @fileoverview Input/output schemas for world-event-ideation-v3.
 *
 * This agent generates ideas for significant events (historical events, prophecies, legends).
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';
import { AGENT_SCHEMA_OBJECTS } from '@/ai/agents/prompt-variables';
import { WorldEventIdeaV3Schema, WorldEventElementEnum } from '@/domains/world-building/schemas';

export const InputSchema = z.object({
  ...BaseFlowInputSchema.shape,
  ...AGENT_SCHEMA_OBJECTS.storyContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.loreContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.worldElements.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.worldEvents.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.characters.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.initialChapterContent.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.userMessage.schema.shape,
  targetElement: WorldEventElementEnum.optional().describe(
    'Optional filter to generate only a specific element type (historical-event, prophecy, or legend). If not provided, generates a mix.'
  ),
});

export type Input = z.infer<typeof InputSchema>;

const WorldEventIdeaOutputSchema = WorldEventIdeaV3Schema.omit({
  tempId: true,
  source: true,
});

export const OutputSchema = z.object({
  events: z.array(WorldEventIdeaOutputSchema).describe('An array of generated world event ideas.'),
});

export type Output = z.infer<typeof OutputSchema>;
